import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod/v3'
import { RbacAccessDenied } from '~/components/routes/administration/roles/access-denied'
import { CamerasPage } from '~/components/routes/cameras/page/cameras-page'
import { CAMERA_STREAM_READ } from '~/components/routes/cameras/permissions'
import { usePermissionGuard, withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/cameras/new')({
  staticData: {
    permission: CAMERA_STREAM_READ,
  },
  component: CamerasNewPage,
  validateSearch: z.object({
    storeId: z.number().int().positive().optional(),
    focusedCameraId: z.number().int().positive().optional(),
    mode: z.enum(['boutique', 'views']).optional(),
    viewId: z.string().optional(),
    // Panneau « Contrôle du panier » ouvert sur cette caisse ; une valeur illisible le laisse fermé.
    controle: z.number().int().positive().optional().catch(undefined),
  }),
})

withRoutePermissions(Route)

function CamerasNewPage() {
  const canRead = usePermissionGuard(CAMERA_STREAM_READ).authorized

  if (!canRead) return <RbacAccessDenied />

  return <CamerasPage />
}
